import React, { useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Button } from "@material-ui/core";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import apiform from "utils/APIForm";
import { getListAllSupplies } from 'actions/getListAction';


export default function ModalAcept2Request(props) {
  const {
    open,
    closeModal,
    divisionRequest,
    stockProductoFraccionar,
    stockProductoFraccionado
  } = props;

  const dispatch = useDispatch();
  const chargeAllSupplies = useSelector(state => state.currentGlobalVar.chargeAllSupplies);

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const [scroll, setScroll] = useState("paper");

  function updateDivision() {
    const formData = new FormData();

    formData.append("cantidad_fraccionar", divisionRequest.cantidad_fraccionar);
    formData.append("observaciones", divisionRequest.observaciones);
    formData.append("cantidad_resultante", props.cantidad_resultante);
    formData.append("estado", "Finalizado");
    formData.append(
      "id_producto_fraccionar",
      divisionRequest.id_producto_fraccionar.id
    );
    formData.append("id_producto_resultante", props.id_producto_resultante);
    formData.append("area", "Ingresos");

    const formDataInsumo = new FormData();

    formDataInsumo.append(
      "stock_producto",
      stockProductoFraccionar - divisionRequest.cantidad_fraccionar
    );

    const formDataInsumoResultante = new FormData();

    formDataInsumoResultante.append(
      "stock_producto",
      stockProductoFraccionado + divisionRequest.cantidad_resultante);

    apiform
      .put(`api/solicitudfraccionamiento/${divisionRequest.id}`, formData)
      .then(response => {
        apiform
          .patch(
            `api/insumosmedicamento/${divisionRequest.id_producto_fraccionar.id}`,
            formDataInsumo
          )
          .then(response => {
            apiform
              .patch(
                `api/insumosmedicamento/${props.id_producto_resultante}`,
                formDataInsumoResultante
              )
              .then(response => {
                getListAllSupplies(dispatch, chargeAllSupplies, true);
                window.location.href = `/admin/income/divisions/${props.moduleType}`;
              })
          })
      })

  }

  return (
    <Dialog
      open={open}
      onClose={closeModal}
      scroll={scroll}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      maxWidth="sm"
      fullWidth={true}
      disableBackdropClick
    >
      <DialogTitle id="scroll-dialog-title">Detalle del pedido</DialogTitle>
      <DialogContent dividers={scroll === "paper"}>
        <div style={{ marginBottom: "10rem" }}>
          <p className="text-center font-weight-bold">
            ¿Está seguro que desea aceptar el fraccionamiento?
          </p>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={updateDivision} color="primary">
          Si
        </Button>
        <Button onClick={closeModal} color="primary">
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ModalAcept2Request.propTypes = {
  open: PropTypes.bool,
  closeModal: PropTypes.func,
  divisionRequest: PropTypes.array,
  stockProductoFraccionar: PropTypes.number,
  stockProductoFraccionado: PropTypes.number
};
